import {Component, OnDestroy, OnInit} from '@angular/core';
import {CustomerService} from '../../../services/customer.service';
import {SharedService} from '../../../services/shared.service';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {takeUntil} from 'rxjs/operators';
import {PaymentDialogComponent} from '../../../components/payment-dialog/payment-dialog.component';
import {Subject} from 'rxjs';
import {CardModel} from '../../../models/card.model';

@Component({
  selector: 'app-payment-page',
  templateUrl: './payment-page.component.html',
  styleUrls: ['./payment-page.component.scss']
})
export class PaymentPageComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  defaultCard: string;
  cards: Array<any> = [];
  showLoader: boolean;

  constructor(private customerService: CustomerService,
              private shared: SharedService,
              private dialog: MatDialog) {
  }

  ngOnInit() {
    this.refreshCards();
  }

  refreshCards() {
    this.showLoader = true;
    this.customerService.getCurrentUser()
      .then(_ => {
        this.customerService.getStripeAccountInfo()
          .then(accountInfo => {
            this.cards = [];
            this.defaultCard = accountInfo['default_source'];
            let sources = accountInfo['sources']['data'] || [];
            sources.forEach(source => {
              if(source.object == 'card') this.cards.push(new CardModel(source));
              if(source.object == 'source' && source.type == 'card') this.cards.push(new CardModel(source.card, source.id));
            });
            this.showLoader = false;
          })
          .catch(res => {
            this.showLoader = false;
            this.shared.openErrorDialog({title: 'Payment error', body: 'Error loading payment information. Please try again.'});
          });
      });

  }

  setDefaultCard(sourceId: string) {
    this.showLoader = true;
    this.customerService.updateStripeInformation({default_source: sourceId})
      .then(_ => {
        this.showLoader = false;
        this.refreshCards();
      })
      .catch(res => {
        this.showLoader = false;
        let err = res.error || res;
        let error = {title: 'Error', body: err.errorMessage || err.message || 'Unexpected error. Please try again'};
        this.shared.openErrorDialog(error);
      });
  }

  deleteCard(sourceId: string) {
    this.showLoader = true;
    this.customerService.deleteCardFromAccount(sourceId)
      .then(_ => {
        this.showLoader = false;
        this.refreshCards();
      })
      .catch(res => {
        this.showLoader = false;
        let err = res.error || res;
        let error = {title: 'Error', body: err.errorMessage || err.message || 'Unexpected error. Please try again'};
        this.shared.openErrorDialog(error);
      });
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      cardFrom: true
    };
    let dialog = this.dialog.open(PaymentDialogComponent, dialogConfig);
    dialog.afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.refreshCards();
      });

  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
